import { render, staticRenderFns } from "./FacilitatorConfig.vue?vue&type=template&id=6c233f4c&scoped=true"
import script from "./FacilitatorConfig.vue?vue&type=script&lang=js"
export * from "./FacilitatorConfig.vue?vue&type=script&lang=js"
import style0 from "./FacilitatorConfig.vue?vue&type=style&index=0&id=6c233f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c233f4c",
  null
  
)

export default component.exports